module.exports = __webpack_public_path__ + "static/media/header-image.4ad87b10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/HeaderImage/header-image.jpg
// module id = 53
// module chunks = 0